module.exports = __webpack_public_path__ + "media/images/icon/icons8-Logout Rounded Up-66f298b7492ea1406efa5487e94c368d.png";